import { IComponentDefintion } from "./interfaces/ComponentDefinition";

const start = require('flow-start-component/components.json');
const api = require('flow-api-component/components');
const cloudboost = require('flow-cloudboost-component/components');
const if_else = require('flow-if-else-component/components');
const json = require('flow-json-component/components');
const stripe = require('flow-stripe-component/components');
const text = require('flow-text-component/components');
const twilio = require('flow-twilio-component/components');
const mailjet = require('flow-mailjet-component/components');
const insert_object = require('flow-insert-object-component/components');

const { keyBy } = require("lodash");

let componentDefinition: IComponentDefintion[] = [
  {
    graphComponentId: "smart-segment",
    title: "Smart Segment Trigger",
    category: "Trigger",
    imgSrc: "/assets/images/icons/smart-segment.svg",
    type: "graphComponent",
    metadata: { "icon-color": "#7ab260" },
    ports: [
      {
        id: "smart-segment-a",
        title: "Smart Segment Trigger A",
        description: "Simple description",
        color: "blue",
        arcColor: "blue"
      },
      {
        id: "smart-segment-b",
        title: "Smart Segment Trigger B",
        description: "Simple description",
        color: "yellow"
      },
      {
        id: "smart-segment-c",
        title: "Smart Segment Trigger C",
        description: "Simple description",
        color: "green"
      },
      {
        id: "smart-segment-d",
        title: "Smart Segment Trigger D",
        description: "Simple description",
        color: "lightblue"
      },
      {
        id: "smart-segment-e",
        title: "Smart Segment Trigger E",
        description: "Simple description",
        color: "#7ab260"
      }
    ],
    properties: [
      {
        categoryName: "General",
        categoryDescription: "Basic settings about this app.",
        properties: [
          {
            id: "title",
            name: "App Name",
            type: "text",
            options: {},
            data: null
          },
          {
            id: "description",
            name: "App Description",
            type: "description",
            options: {},
            data: null
          }
        ]
      },
      {
        categoryName: "Style and Branding",
        categoryDescription: "Change style and branding of your app",
        properties: [
          {
            id: "square-logo",
            name: "Square Logo",
            type: "image",
            options: { sizeRequirement: "square" },
            data: null
          }
        ]
      }
    ],
    showOnComponentsPanel: false,
    isDeletable: false
  },
  {
    graphComponentId: "livechat-tag",
    title: "LiveChat Tag",
    category: "Trigger",
    imgSrc: "/assets/images/icons/liveChat.svg",
    type: "graphComponent",
    metadata: { "icon-color": "#d1683a" },
    ports: [
      {
        id: "livechat-tag-a",
        title: "Live Chat A",
        description: "Simple description",
        color: "rgba(0, 0, 255, 0.5)",
        arcColor: "rgba(0, 0, 255)"
      },
      {
        id: "livechat-tag-b",
        title: "Live Chat B",
        description: "Simple description",
        color: "yellow"
      },
      {
        id: "livechat-tag-c",
        title: "Live Chat C",
        description: "Simple description",
        color: "#279B04",
        arcColor: "#145104"
      },
      {
        id: "livechat-tag-d",
        title: "Live Chat D",
        description: "Simple description",
        color: "#7ab260"
      },
      {
        id: "livechat-tag-e",
        title: "Live Chat E",
        description: "Simple description",
        color: "#d1683a"
      }
    ],
    properties: [
      {
        categoryName: "General",
        categoryDescription: "Basic settings about this app.",
        properties: [
          {
            id: "title",
            name: "App Name",
            type: "text",
            options: {},
            data: null
          },
          {
            id: "description",
            name: "App Description",
            type: "description",
            options: {},
            data: null
          }
        ]
      },
      {
        categoryName: "Style and Branding",
        categoryDescription: "Change style and branding of your app",
        properties: [
          {
            id: "square-logo",
            name: "Square Logo",
            type: "image",
            options: { sizeRequirement: "square" },
            data: null
          }
        ]
      }
    ],
    showOnComponentsPanel: true,
    isDeletable: true
  },
  {
    graphComponentId: "lead-ad-submitted",
    title: "Lead Ad Submitted",
    category: "Trigger",
    imgSrc: "/assets/images/icons/fb_lead_ads.svg",
    type: "graphComponent",
    metadata: { "icon-color": "#4460a0" },
    ports: [
      {
        id: "lead-ad-submitted-a",
        title: "Lead Ad Submitted Trigger A",
        description: "Simple description",
        color: "blue"
      },
      {
        id: "lead-ad-submitted-b",
        title: "Lead Ad Submitted Trigger B",
        description: "Simple description",
        color: "yellow"
      },
      {
        id: "lead-ad-submitted-c",
        title: "Lead Ad Submitted Trigger C",
        description: "Simple description",
        color: "green"
      }
    ],
    properties: [
      {
        categoryName: "General",
        categoryDescription: "Basic settings about this app.",
        properties: [
          {
            id: "title",
            name: "App Name",
            type: "text",
            options: {},
            data: null
          },
          {
            id: "description",
            name: "App Description",
            type: "description",
            options: {},
            data: null
          }
        ]
      },
      {
        categoryName: "Style and Branding",
        categoryDescription: "Change style and branding of your app",
        properties: [
          {
            id: "square-logo",
            name: "Square Logo",
            type: "image",
            options: { sizeRequirement: "square" },
            data: null
          }
        ]
      }
    ],
    showOnComponentsPanel: true,
    isDeletable: true
  },
  {
    graphComponentId: "delay",
    title: "Add Delay",
    category: "Actions",
    imgSrc: "/assets/images/icons/trigger-timer.svg",
    type: "graphComponent",
    metadata: { "icon-color": "#fb7138" },
    ports: [
      {
        id: "delay-a",
        title: "Add Delay A",
        description: "Simple description",
        color: "#00D4AB"
      }
    ],
    properties: [
      {
        categoryName: "General",
        categoryDescription: "Basic settings about this app.",
        properties: [
          {
            id: "title",
            name: "App Name",
            type: "text",
            options: {},
            data: null
          },
          {
            id: "description",
            name: "App Description",
            type: "description",
            options: {},
            data: null
          }
        ]
      },
      {
        categoryName: "Style and Branding",
        categoryDescription: "Change style and branding of your app",
        properties: [
          {
            id: "square-logo",
            name: "Square Logo",
            type: "image",
            options: { sizeRequirement: "square" },
            data: null
          }
        ]
      }
    ],
    showOnComponentsPanel: true,
    isDeletable: true
  },
  {
    graphComponentId: "send-mail",
    title: "Send Email",
    category: "Actions",
    imgSrc: "/assets/images/icons/email.svg",
    type: "graphComponent",
    metadata: { "icon-color": "#f0b029" },
    ports: [
      {
        id: "send-mail-a",
        title: "Send Email A",
        description: "Simple description",
        color: "blue"
      },
      {
        id: "send-mail-b",
        title: "Send Email B",
        description: "Simple description",
        color: "#f0b029"
      },
      {
        id: "send-mail-c",
        title: "Send Email C",
        description: "Simple description",
        color: "green"
      },
      {
        id: "send-mail-d",
        title: "Send Email D",
        description: "Simple description",
        color: "lightblue"
      }
    ],
    properties: [
      {
        categoryName: "General",
        categoryDescription: "Basic settings about this app.",
        properties: [
          {
            id: "title",
            name: "App Name",
            type: "text",
            options: {},
            data: null
          },
          {
            id: "description",
            name: "App Description",
            type: "description",
            options: {},
            data: null
          }
        ]
      },
      {
        categoryName: "Style and Branding for Email Component",
        categoryDescription: "Change style and branding of your app",
        properties: [
          {
            id: "square-logo",
            name: "Square Logo",
            type: "image",
            options: { sizeRequirement: "square" },
            data: null
          }
        ]
      }
    ],
    showOnComponentsPanel: true,
    isDeletable: true
  },
  {
    graphComponentId: "send-sms",
    title: "Send SMS",
    category: "Actions",
    imgSrc: "/assets/images/icons/twilio.svg",
    type: "graphComponent",
    metadata: { "icon-color": "#f22f46" },
    ports: [
      {
        id: "send-sms-a",
        title: "Send Sms A",
        description: "Simple description",
        color: "red"
      },
      {
        id: "send-sms-b",
        title: "Send Sms B",
        description: "Simple description",
        color: "blue"
      },
      {
        id: "send-sms-c",
        title: "Send Sms C",
        description: "Simple description",
        color: "pink"
      }
    ],
    properties: [
      {
        categoryName: "General",
        categoryDescription: "Basic settings about this app.",
        properties: [
          {
            id: "title",
            name: "App Name",
            type: "text",
            options: {},
            data: null
          },
          {
            id: "description",
            name: "App Description",
            type: "description",
            options: {},
            data: null
          }
        ]
      },
      {
        categoryName: "Style and Branding",
        categoryDescription: "Change style and branding of your app",
        properties: [
          {
            id: "square-logo",
            name: "Square Logo",
            type: "image",
            options: { sizeRequirement: "square" },
            data: null
          }
        ]
      }
    ],
    showOnComponentsPanel: true,
    isDeletable: true
  },
  {
    graphComponentId: "has-submitted-typeform",
    title: "Has Submitted Typeform",
    category: "Conditions",
    imgSrc: "/assets/images/icons/typeform.svg",
    type: "graphComponent",
    metadata: { "icon-color": "#262627" },
    ports: [
      {
        id: "has-submitted-typeform-a",
        title: "Has Submitted Typeform A",
        description: "Simple description",
        color: "#262627"
      },
      {
        id: "has-submitted-typeform-b",
        title: "Has Submitted Typeform B",
        description: "Simple description",
        color: "yellow"
      },
      {
        id: "has-submitted-typeform-c",
        title: "Has Submitted Typeform C",
        description: "Simple description",
        color: "green"
      }
    ],
    properties: [
      {
        categoryName: "General",
        categoryDescription: "Basic settings about this app.",
        properties: [
          {
            id: "title",
            name: "App Name",
            type: "text",
            options: {},
            data: null
          },
          {
            id: "description",
            name: "App Description",
            type: "description",
            options: {},
            data: null
          }
        ]
      },
      {
        categoryName: "Style and Branding",
        categoryDescription: "Change style and branding of your app",
        properties: [
          {
            id: "square-logo",
            name: "Square Logo",
            type: "image",
            options: { sizeRequirement: "square" },
            data: null
          }
        ]
      }
    ],
    showOnComponentsPanel: true,
    isDeletable: true
  },
  {
    graphComponentId: "check-deal-stage",
    title: "Check Deal Stage",
    category: "Conditions",
    imgSrc: "/assets/images/icons/pipedrive.svg",
    type: "graphComponent",
    metadata: { "icon-color": "#26292a" },
    ports: [
      {
        id: "check-deal-stage-a",
        title: "Check Deal Stage A",
        description: "Simple description",
        color: "#26292a"
      },
      {
        id: "check-deal-stage-b",
        title: "Check Deal Stage B",
        description: "Simple description",
        color: "yellow"
      },
      {
        id: "check-deal-stage-c",
        title: "Check Deal Stage C",
        description: "Simple description",
        color: "green"
      },
      {
        id: "check-deal-stage-d",
        title: "Check Deal Stage D",
        description: "Simple description",
        color: "lightblue"
      }
    ],
    properties: [
      {
        categoryName: "General",
        categoryDescription: "Basic settings about this app.",
        properties: [
          {
            id: "title",
            name: "App Name",
            type: "text",
            options: {},
            data: null
          },
          {
            id: "description",
            name: "App Description",
            type: "description",
            options: {},
            data: null
          }
        ]
      },
      {
        categoryName: "Style and Branding",
        categoryDescription: "Change style and branding of your app",
        properties: [
          {
            id: "square-logo",
            name: "Square Logo",
            type: "image",
            options: { sizeRequirement: "square" },
            data: null
          }
        ]
      }
    ],
    showOnComponentsPanel: true,
    isDeletable: true
  },
  {
    graphComponentId: "check-headsup-status",
    title: "Check Headsup Status",
    category: "Conditions",
    imgSrc: "/assets/images/icons/headsup.svg",
    type: "graphComponent",
    metadata: { "icon-color": "#ee336d" },
    ports: [
      {
        id: "check-headsup-a",
        title: "Check Headsup Status A",
        description: "Simple description",
        color: "#26292a"
      },
      {
        id: "check-headsup-b",
        title: "Check Headsup Status B",
        description: "Simple description",
        color: "yellow"
      },
      {
        id: "check-headsup-c",
        title: "Check Headsup Status C",
        description: "Simple description",
        color: "#ee336d"
      },
      {
        id: "check-headsup-d",
        title: "Check Headsup Status D",
        description: "Simple description",
        color: "lightblue"
      }
    ],
    properties: [
      {
        categoryName: "General",
        categoryDescription: "Basic settings about this app.",
        properties: [
          {
            id: "title",
            name: "App Name",
            type: "text",
            options: {},
            data: null
          },
          {
            id: "description",
            name: "App Description",
            type: "description",
            options: {},
            data: null
          }
        ]
      },
      {
        categoryName: "Style and Branding",
        categoryDescription: "Change style and branding of your app",
        properties: [
          {
            id: "square-logo",
            name: "Square Logo",
            type: "image",
            options: { sizeRequirement: "square" },
            data: null
          }
        ]
      }
    ],
    showOnComponentsPanel: true,
    isDeletable: true
  }
];

export const components = componentDefinition.concat(
  Object.values(
    Object.assign(
      {},
      start,
      api,
      cloudboost,
      json,
      if_else,
      insert_object,
      mailjet,
      start,
      stripe,
      text,
      twilio,
    ),
  )
);

export const componentsByType: {
  [componentType: string]: IComponentDefintion;
} = keyBy(components, "graphComponentId");
